import MapInfoWindow from './MapInfoWindow';

export default MapInfoWindow;
